import {
  getUrlPathForAnalytics,
  handleLinkAndModalTrack,
} from './adobeTrackUtils';

export { handleLinkAndModalTrack, getUrlPathForAnalytics };
